"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthoredFields = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const form_text_field_1 = require("../../form/fields/form-text-field");
function AuthoredFields(options) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        options.FieldsComponent && react_1.default.createElement(options.FieldsComponent, null),
        react_1.default.createElement(form_text_field_1.FormTextField, { name: "createdBy.name", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_FIELD_LABEL_CREATED_BY", defaultMessage: "Autor" }), disabled: true }),
        react_1.default.createElement(form_text_field_1.FormTextField, { name: "updatedBy.name", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_FIELD_LABEL_UPDATED_BY", defaultMessage: "Autor \u00FApravy" }), disabled: true })));
}
exports.AuthoredFields = AuthoredFields;
//# sourceMappingURL=authored-fields.js.map